import gsap from 'gsap/dist/gsap'
import { useLayoutEffect, useRef } from 'react'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { Breakpoint, useCheckBreakpoint } from '~/utils'

import StrokeText from './StrokeText'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '40px' }]

const AnimationXp = ({ noOfXPs }: { noOfXPs: number }): React.ReactElement => {
  const xpRef = useRef(null)
  const isMobile = useCheckBreakpoint({ lt: Breakpoint.MD })

  // Shorter path for mobile since chest is small
  const animationPath = isMobile
    ? 'M5.138,23.788 C7.326,-24.055 -30.886,4.305 -64.013,10.183'
    : 'M5.138,23.788 C7.326,-24.055 -46.588,4.603 -79.688,10.475 '

  useLayoutEffect(() => {
    gsap.set(xpRef.current, { xPercent: -50, yPercent: -50, transformOrigin: '50% 50%' })
    gsap.to(xpRef.current, {
      duration: 1,
      motionPath: {
        path: animationPath,
      },
    })

    gsap.to(xpRef.current, {
      duration: 2,
      delay: 2.2,
      opacity: 0,
    })

    // MotionPathHelper.create(xpRef.current)
  }, [animationPath])

  return (
    <div
      className="flex flex-col items-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10"
      ref={xpRef}
    >
      <StrokeText className="leading-4">+{noOfXPs}</StrokeText>
      <ResponsiveImage
        imageClassName="!my-0"
        imageWidths="60"
        mediaQuery={mediaQuery}
        srcKey="bootcamp/xp-icon.png"
        width={60}
      />
    </div>
  )
}

export default AnimationXp
